import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { useEntitlements } from './useEntitlements'

/** Προστατεύει διαδρομές Pro (έργα, κριτικές, δημόσιο προφίλ). */
export function RequirePackage2() {
  const { user, isReady } = useAuth()
  const { hasPackageGate } = useEntitlements()

  if (!isReady) {
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center text-sm text-zinc-600 dark:text-zinc-400">
        Φόρτωση…
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (!hasPackageGate(2)) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
